export default __webpack_public_path__ + "static/media/AasthaArora.da634a9b.jpeg";